export const apiVersionPrefix = "/api/v3";

export const tripSummariesApiPrefix = `${apiVersionPrefix}/shopSummary`;
